export const ItemTypes = {
  FIELD: 'customLocationDetails',
};

export const defaultDeleteCandidateOptions = {
  id: '',
  fieldName: '',
};
